// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {ReactNode, useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import {useHistory, useLocation} from 'react-router-dom';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {use_scrolled} from '../../../../hola/pub/ui_utils';
import {i_nav_opt, t_route, t_route_fields} from '../../types/route';

const r_or_call = (v, default_value?)=>{
    if (v===undefined && default_value!==undefined)
        return default_value;
    if (typeof v=='function')
        return v();
    return v;
};

export type use_navbar_props = {
    user_country?: string;
    route?: t_route;
    nav_opt?: i_nav_opt;
    route_opt?: t_route_fields;
    burger_pos?: 'left' | 'right';
    headlogo?:boolean;
}

export const use_navbar = (props: use_navbar_props)=>{
    const {route, user_country, burger_pos = 'right'} = props;
    const {is_client, is_plus, user} = use_app_context();
    const {y} = use_scrolled();
    const app_route_opt = props.route_opt || {};
    const [opened, set_opened] = useState(false);
    const [is_navigating, set_is_navigating] = useState(false);
    const {pathname} = useLocation();
    const history = useHistory();
    const path = useRef(pathname);
    useEffect(()=>{
        history.listen((location, action)=>{
            if (action === 'PUSH' && location.pathname!=path.current)
            {
                set_is_navigating(true);
                path.current = location.pathname;
            }
        });
    }, []);
    const headlogo: boolean =
        props.headlogo || route && r_or_call(route.headlogo,
            app_route_opt.headlogo);
    const headless: boolean = route && r_or_call(route.headless,
        app_route_opt.headless);
    const cp_link: string = route && r_or_call(route.cp_link,
        app_route_opt.cp_link);
    const cp_after_login: boolean = route && r_or_call(route.cp_after_login,
        app_route_opt.cp_after_login);
    const nav_opt: i_nav_opt = Object.assign(route && r_or_call(route.nav_opt)
        || {}, props.nav_opt || {});
    const toggle = (state?: boolean)=>{
        if (state === undefined)
            set_opened(v=>!v);
        else
            set_opened(state);
    };
    useEffect(()=>{
        toggle(false);
        setTimeout(()=>{
            set_is_navigating(false);
        }, 100);
    }, [pathname]);
    return {is_client, is_plus, is_scrolled: y > 0, has_user: !!user, opened,
        user_country, headlogo, headless, nav_opt, toggle,
        cp_link, cp_after_login, burger_pos, is_navigating};
};

/* eslint-disable */
export enum NAVBAR_SLOTS {
    mobile_left = 'mobile_left',
    mobile_mid = 'mobile_mid',
    mobile_right = 'mobile_right',
}
/* eslint-enable */

interface i_navbar_portal_props {
    slot: NAVBAR_SLOTS;
    children: ReactNode;
}

export const Navbar_portal = ({slot, children}: i_navbar_portal_props)=>{
    const slot_el = document.querySelector(`*[data-slot=${slot}]`);
    return slot && slot_el ? createPortal(children, slot_el) : null;
};
